export enum SUPPORTED_COUNTRY {
  ANDORRA = "AD",
  BELGIUM = "BE",
  CYPRUS = "CY",
  FRANCE = "FR",
  GERMANY = "DE",
  ITALY = "IT",
  LUXEMBOURG = "LU",
  MONACO = "MC",
  MOROCCO = "MA",
  NETHERLANDS = "NL",
  PORTUGAL = "PT",
  SPAIN = "ES",
  SWITZERLAND = "CH",
  UNITED_KINGDOM = "GB",
}

// Chypre et le Maroc ne sont ouverts qu'aux prestataires de masterclass externe, pas aux structures Opera Off
// (onboarding et profils professeur/prestataire).
export const EUROPEAN_COUNTRIES = Object.values(SUPPORTED_COUNTRY).filter(
  c => c !== SUPPORTED_COUNTRY.MOROCCO && c !== SUPPORTED_COUNTRY.CYPRUS,
);

export const COUNTRY_LABELS: Record<SUPPORTED_COUNTRY, { label: string; flag: string }> = {
  [SUPPORTED_COUNTRY.ANDORRA]: { label: "Andorre", flag: "\u{1F1E6}\u{1F1E9}" },
  [SUPPORTED_COUNTRY.BELGIUM]: { label: "Belgique", flag: "\u{1F1E7}\u{1F1EA}" },
  [SUPPORTED_COUNTRY.CYPRUS]: { label: "Chypre", flag: "\u{1F1E8}\u{1F1FE}" },
  [SUPPORTED_COUNTRY.FRANCE]: { label: "France", flag: "\u{1F1EB}\u{1F1F7}" },
  [SUPPORTED_COUNTRY.GERMANY]: { label: "Allemagne", flag: "\u{1F1E9}\u{1F1EA}" },
  [SUPPORTED_COUNTRY.ITALY]: { label: "Italie", flag: "\u{1F1EE}\u{1F1F9}" },
  [SUPPORTED_COUNTRY.LUXEMBOURG]: { label: "Luxembourg", flag: "\u{1F1F1}\u{1F1FA}" },
  [SUPPORTED_COUNTRY.MONACO]: { label: "Monaco", flag: "\u{1F1F2}\u{1F1E8}" },
  [SUPPORTED_COUNTRY.MOROCCO]: { label: "Maroc", flag: "\u{1F1F2}\u{1F1E6}" },
  [SUPPORTED_COUNTRY.NETHERLANDS]: { label: "Pays-Bas", flag: "\u{1F1F3}\u{1F1F1}" },
  [SUPPORTED_COUNTRY.PORTUGAL]: { label: "Portugal", flag: "\u{1F1F5}\u{1F1F9}" },
  [SUPPORTED_COUNTRY.SPAIN]: { label: "Espagne", flag: "\u{1F1EA}\u{1F1F8}" },
  [SUPPORTED_COUNTRY.SWITZERLAND]: { label: "Suisse", flag: "\u{1F1E8}\u{1F1ED}" },
  [SUPPORTED_COUNTRY.UNITED_KINGDOM]: { label: "Royaume-Uni", flag: "\u{1F1EC}\u{1F1E7}" },
};
